import { motion } from "framer-motion";

const CheckEmail = ({ email }) => {
  return (
    <motion.div
      className="w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="grid h-full grid-cols-1 gap-0 md:grid-cols-2">
        <div className="flex flex-col px-6 py-16 bg-gray-50 md:px-10 md:py-10 lg:px-16 lg:py-16">
          <h1 className="text-base font-bold text-as-green-100 md:text-lg">
            Check Your Email
          </h1>
          <h2 className="mt-2 mb-4 text-3xl md:mb-5 md:mt-3 md:text-4xl">
            We've sent you a login link!
          </h2>
          <p>
            We've sent a secure login link to your email address. Please check your inbox and click the link to continue.
          </p>
          {email && (
            <p className="mt-4 text-sm text-gray-600">
              Email sent to: <strong>{email}</strong>
            </p>
          )}
          <p className="mt-8 text-xs md:mt-auto">
            We use Bank-level, 256-bit encryption to keep your data safe.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center px-6 py-16 bg-white md:px-10 lg:px-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-as-green-50 rounded-full flex items-center justify-center">
              <svg 
                className="w-8 h-8 text-as-green-100" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Check your email
            </h3>
            <p className="text-gray-600 mb-6">
              Click the link in your email to sign in to your account.
            </p>
            <div className="text-sm text-gray-500">
              <p>Didn't receive the email?</p>
              <p className="mt-1">Check your spam folder or contact support.</p>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default CheckEmail;
